export default __webpack_public_path__ + "static/media/melody2.36131be1.png";